export const STACKS_NETWORK_TYPE = 'mainnet'
export const STACKS_NETWORK = 'mainnet'
export const STACKS_ADDRESS_VERSION = 22
export const STACKS_RPC_URL = `https://api.${STACKS_NETWORK_TYPE}.hiro.so`
